import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';

const API_BASE_URL = 'https://api.wiseclean.ee/api:56Z3lZ-0';


/*const loadTelegramScript = () => {
    const script = document.createElement("script");
    script.src = "https://telegram.org/js/telegram-web-app.js";
    script.async = true;
    document.body.appendChild(script);
};*/

const OrderAnnounce = () => {
    const { orderId } = useParams();
    const [orderDetails, setOrderDetails] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);



    useEffect(() => {
        if (window.Telegram && window.Telegram.WebApp) {
            window.Telegram.WebApp.expand(); // Развернуть WebApp
            window.Telegram.WebApp.ready(); // Подготовить WebApp
        }
    }, []);

    useEffect(() => {
        const fetchOrderDetails = async () => {
            try {
                const response = await fetch(`${API_BASE_URL}/get_old_order_details?orderID=${orderId}&locale=en`);
                const data = await response.json();
                setOrderDetails(data);
            } catch (err) {
                setError('Ошибка загрузки данных');
                console.error(err);
            } finally {
                setLoading(false);
            }
        };

        fetchOrderDetails();
    }, [orderId]);

    const handleArrivalStatus = async (timeShift) => {
        try {
            const response = await fetch(`${API_BASE_URL}/cleaner_arrive?orderID=${orderId}&time_shift=${timeShift}`, {
                method: 'GET',
            });
            const result = await response.json();
            alert(`Ответ сервера: ${JSON.stringify(result)}`);
        } catch (err) {
            alert('Ошибка при отправке данных');
            console.error(err);
        }
    };

    if (loading) return <p>Загрузка...</p>;
    if (error) return <p>{error}</p>;

    return (
        <div style={styles.container}>
            <h2>Заказ {orderDetails.date} {orderDetails.time}</h2>
            <p><strong>{orderDetails.address}</strong></p>

            <div style={styles.buttonContainer}>
                <button style={styles.earlyButton} onClick={() => handleArrivalStatus('-10')}>
                    Буду на 10 минут раньше
                </button>

                <button style={styles.onTimeButton} onClick={() => handleArrivalStatus('0')}>
                    Буду во время
                </button>

                <button style={styles.lateButton} onClick={() => handleArrivalStatus('+15')}>
                    Буду на 15 минут позже
                </button>
            </div>

            <p style={styles.notice}>*Если Вы опаздываете более чем на 15 минут, пишите в чат!</p>
        </div>
    );
};

const styles = {
    container: { padding: '20px', textAlign: 'center', fontFamily: 'Arial, sans-serif' },
    buttonContainer: { display: 'flex', flexDirection: 'column', gap: '15px', marginTop: '20px' },
    earlyButton: { backgroundColor: '#c1ca5f', color: 'white', padding: '10px', border: 'none', borderRadius: '5px', cursor: 'pointer' },
    onTimeButton: { backgroundColor: '#4CAF50', color: 'white', padding: '10px', border: 'none', borderRadius: '5px', cursor: 'pointer' },
    lateButton: { backgroundColor: '#f44336', color: 'white', padding: '10px', border: 'none', borderRadius: '5px', cursor: 'pointer' },
    notice: { marginTop: '20px', fontSize: '14px', color: '#555' },
};

export default OrderAnnounce;